import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { getAggregateStatisticsPreference, setAggregateStatisticsPreference } from '@/lib/firstPartyFunnel';
const CookiePolicyPage = () => {
  const [aggregateStatistics, setAggregateStatistics] = useState('on');
  useEffect(() => {
    window.scrollTo(0, 0);
    setAggregateStatistics(getAggregateStatisticsPreference());
  }, []);
  const updateAggregateStatistics = (preference) => {
    setAggregateStatisticsPreference(preference);
    setAggregateStatistics(preference);
  };
  return <>
      <Helmet>
        <title>Cookie Policy - PhantomPathVPN Ltd</title>
        <meta name="description" content="Cookie Policy for PhantomPathVPN Ltd." />
      </Helmet>
      <div className="pt-32 pb-24 px-4 bg-[#0a0a0a] min-h-screen text-gray-300">
        <div className="container mx-auto max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-[#3affc2]">Cookie Policy</h1>
          <p className="text-gray-400 mb-12">PhantomPathVPN Ltd | Company Number: 16958507</p>

          <div className="space-y-8 leading-relaxed bg-[#111] p-8 rounded-2xl border border-white/10">
            <section>
              <p className="text-lg">
                PhantomPathVPN Ltd uses cookies to ensure the proper functioning of our website and to improve user experience. ​Compliance & Minors: PhantomPath services are strictly for users aged 18 and over. In accordance with our data minimisation philosophy, we do not use cookies or any tracking technologies for the purpose of identifying, profiling, or monitoring minors.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">Essential Cookies:</h2>
              <p>
                Required for website security and core functionality. We also store your cookie-consent choice locally so the site can remember it. These functions remain available when optional cookies are rejected.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">Analytics Cookies:</h2>
              <p>
                Google Analytics 4 is configured through Google Consent Mode v2. Analytics and advertising storage are denied by default. When optional cookies are rejected, Google may receive consent-state and cookieless measurement signals without setting optional analytics or advertising cookies. Full analytics storage is enabled only after you accept optional cookies.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">Anonymous First-Party Statistics:</h2>
              <p>
                We count a small number of purchase-funnel steps in daily aggregate totals to understand where the checkout service needs improvement. These totals contain only the funnel step and an approved product SKU and are deleted after 90 days. They do not contain an IP address, user agent, cookie, visitor or session identifier, device identifier, fingerprint, or advertising identifier, and they are not sent to advertising platforms. The setting below stores only your on/off preference on this device and is never attached to a funnel event.
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-2">
                <span className="text-sm text-gray-300">Anonymous statistics are currently {aggregateStatistics === 'off' ? 'off' : 'on'}.</span>
                <button type="button" onClick={() => updateAggregateStatistics('off')} className="rounded-md border border-white/20 px-3 py-2 text-sm text-white hover:bg-white/10">Object and turn off</button>
                <button type="button" onClick={() => updateAggregateStatistics('on')} className="rounded-md border border-[#3affc2]/40 px-3 py-2 text-sm text-[#3affc2] hover:bg-[#3affc2]/10">Allow anonymous statistics</button>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">Advertising Measurement:</h2>
              <p>
                Meta Pixel and TikTok Pixel are optional advertising-measurement technologies. They are not loaded until you accept optional cookies. They remain disabled throughout the private customer portal. If optional consent was already granted, the payment-success page may send a limited confirmed-purchase event containing the product, duration, GBP value, quantity and an anonymous conversion reference. Access codes, recovery keys, provider session tokens and communications content are never included.
              </p>
            </section>

            <section>
              <p className="font-medium text-white p-4 bg-[#1e293b]/50 rounded-lg border-l-4 border-[#3affc2]">
                You may accept or reject optional cookies from the banner. Closing the banner with the X rejects optional cookies. You can review your choice later by selecting Cookie Settings in the website footer.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>;
};
export default CookiePolicyPage;
